__turbopack_context__.v({
  "disabled": "styles-module-scss-module__B1hz3G__disabled",
  "menuDesktop": "styles-module-scss-module__B1hz3G__menuDesktop",
  "menuDesktopCollapse": "styles-module-scss-module__B1hz3G__menuDesktopCollapse",
  "menuTrigger": "styles-module-scss-module__B1hz3G__menuTrigger",
});
